import * as angular from "angular";

let HelpOptionController = {
    selector: "vcHelpOption",
    templateUrl: "/angular/components/cancel/help-option.component.html",
    bindings: {
        showFeedback: "=",
    },
    controller: class HelpOptionController {
        // * bindings for typescript compiler *
        public showFeedback: any;
        // ************************************
    },
};

angular
    .module("cancel")
    .component(HelpOptionController.selector, HelpOptionController);
